import Vue from "vue";
import VueI18n from "vue-i18n";
const messages = {
    en: {
        header: {
            "Campings Clubs": "Campsites Clubs",
            "Ventes Flash": "Flash Sales",
            "A propos": "About",
            "On parle de nous": "We talk about us",
            FAQ: "FAQ",
            "Contactez-nous": "Contact us"
        },
        searchBar: {
            "Tous les campings clubs": "All club campsites",
            Chalets: "Chalets",
            Arrivée: "Arrival",
            Départ: "Departure",
            adultes: "adults",
            Rechercher: "Search",
            "Please select": "Please select"
        },
        app: {
            profiter: "enjoy",
            "Nos offres du moment": "Our current offers",
            "j’en profite": "I take advantage",
            "à partir de": "from",
            découvrir: "discover",
            "Nos types d’hébergements": "Our types of accommodation",
            "NOs valeurs": "Our values",
            confort: "comfort",
            "confort description":
                "Free WiFi, activities, beach or swimming pool, market, convenience store, a wide choice at the service of our customers.",
            sécurité: "security",
            "security description": "Dual electronic and guard surveillance",
            propreté: "cleanliness",
            "cleanliness description":
                "Installations to international standards, modern sanitary blocks.",
            services: "services",
            "service description":
                "Our services guarantee moments of pleasure, rest and comfort.",
            "dernières news": "latest news",
            "Notre actualité": "latest news",
            "voir toutes les actualités": "see all the news",
            Home: "Home",
            Recherche: "Research",
            "Camping Imourane": "Imourane Campsite",
            Panier: "Basket",
            "Services et options": "Services et options",
            Options: "Options",
            Restauration: "Restoration",
            "étape 1": "Step 1",
            "Votre réservation": "Your reservation",
            sélectionnez: "select",
            "vos services & options": "your services & options",
            "votre mode de paiement": "your payment method",
            "votre réservation": "your reservation",
            "est enregistrée": "is registered",
            "Retour au panier": "Bacl to cart",
            Paiement: "Payment",
            "Complétez les champs d’information et choisissez votre mode de paiement :":
                "Complete the information fields and choose your method of payment :",
            "reservation on behalf of": "reservation on behalf of",
            Prénom: "Forname",
            Nom: "Name",
            "Adresse Email": "Email address",
            Téléphone: "Phone number",
            "Mode de paiement": "Method of payment",
            "Je paie": "No card payment is required today.",
            "un acompte pour confirmer ma réservation*":
                "You will pay during your stay.",
            "the rest to be paid will be paid on site": "",
            "Payer par carte bleue": "Book with credit card",
            Virement: "Bank transfer",
            "Numéro de carte": "Credit card number",
            Month: "Month",
            Year: "Year",
            "Code de sécurité": "Security number",
            "Nom du titulaire": "Name on the card",
            "*Remboursable jusqu’à 30 jours avant le début du séjour":
                "*Refundable up to 2 days before the start of the stay",
            "J’accepte les": "I accept the",
            "Conditions Générales de Vente": "Terms of Sales",
            "J’accepte de recevoir des offres ou informations de la part d’Atlantica Parc":
                "I agree to receive offers or information from Atlantica Parc",
            "Procéder au paiement": "Proceed to payment",
            "Paiement par virement": "Pay by bank transfer",
            "Nous vons avons envoyé un récapitulatif de votre réservation ainsi qu’un":
                "We have sent you your booking informations and a",
            "Relevé d’identé Bancaire sur l’adresse mail indiquée.":
                "Bank Identity Statement on the email address indicated.",
            "Nous vous invitons à effectuer le virement sur le compte indiqué. Votre réservation restera":
                "We invite you to make the transfer to the account indicated. Your reservation will remain",
            "enregistrée pendant 5 jours,</b> jusqu’à réception de votre paiement. Si le paiement n’est pas reçu dans les 5 jours ouvrés,":
                "saved for 5 days, </b> until we receive your payment. If payment is not received within 5 business days,",
            "la réservation sera annulée.": "the reservation will be canceled.",
            "contacter notre service client": "contact our customer service",
            "en savoir plus": "learn more",
            "On parle de nous": "We talk about us",
            Blog: "Blog",
            "Featured Blogs": "Featured Blogs",
            "View all": "View all",
            "Related posts": "Related posts",
            adultes: "adults",
            "réserver dans ce parc": "book in this park",
            localisation: "Location",
            "Offer title": "Jobs",
            "Current Openings": "Current Openings",
            Apply: "Apply",
            "Toutes catégories": "All categories",
            "Filtrer par": "Filter by",
            Du: "From",
            au: "to",
            "A propos": "About",
            CGU: "Terms of Service",
            CGV: "Terms of Sales",
            "Plan de site": "Sitemap",
            "Offres d’emplois": "Jobs",
            "Mentions Légales": "Legal Notice",
            "Modalités de Paiement": "Payment terms",
            Services: "Services",
            résultats: "results",
            offres: "offers",
            "correspondent à votre recherche": "No match within for these dates",
            "Voir nos offres disponibles": "See our available offers",
            jeu: "jeu",
            "Most read": "Most read",
            "(en 2 min Chrono)": "(in 2 min Chrono)",
            Inclus: "Annexes",
            réserver: "book",
            choisissez: "choose",
            "Date d’arrivée": "Arrival date",
            "Date de départ": "Date of departure",
            "Total Services": "Total Services",
            Total: "Total",
            Modifier: "Edit",
            Valider: "Validate",
            Adultes: "Adults",
            "plus d’infos": "see more",
            "par personne": "per person",
            Ajouter: "Add",
            "Code Promo": "Promo Code",
            Voucher: "Voucher",
            "Your code promo is not valid": "Your code promo is not valid",
            équipement: "equipment",
            Situation: "Pictures",
            "Nos services et activités": "Our services and activities",
            "Share this story": "Share this story",
            "This field is required": "This field is required",
            "First name is required": "First name is required",
            "Last name is required": "Last name is required",
            "Email address is required": "Email address is required",
            "Telephone is required": "Telephone is required",
            "Card number is required": "Card number is required",
            "Month is required": "Month is required",
            "Year is required": "The year is 4 digits number",
            "Cvv is required": "Cvv is required",
            "Name is required": "Name is required",
            "Date expiration": "Expiration date",
            Code: "Code",
            "Your reservation is confirmed": "Your reservation is confirmed",
            "Your reservation failed": "The dates chosen are no longer available, refresh the site by typing CTRL + R on your keyboard and search for availability again",
            "We have sent a summary of your reservation to the email address provided":
                "We have sent you a summary of your reservation at the indicated email address.",
            "Nous vous remercions de votre confiance":
                "We thank you for your confidence",
            "Back to the homepage": "Back to the homepage",
            "An error occurred during your payment":
                "An error occurred during your payment",
            "Veuillez recommencer": "Please rebook",
            Send: "Send",
            "Contact Us": "Contact Us",
            "Campings Clubs": "Campings Clubs",
            "Enter name": "Enter name",
            "Enter email": "Enter email",
            "Your message": "Your message",
            "Thank your for contact": "Thank your for contact",
            Successfully: "Successfully",
            "Offre promotionnelle": "Promotional offer",
            "Taxes de séjour": "Tourist taxes",
            "Total de l’hébergement": "Total accommodation",
            "CGU & CGV": "Terms of use & terms of sale",
            "vente flash": "Flash sale",
            Adulte: "Adult",
            Adolescent: "Teenager",
            Enfant: "Kid",
            Animal: "Animal",
            "étape suivante": "Next step",
            jours: "days",
            nuits: "nights",
            nuit: "night",
            child: "Child",
            bébé: "baby",
            "Please correct expiration": "Please correct expiration",
            Error: "Error",
            "Please select camping, type, date from, date to, adults":
                "Please complete all field to make a research",
            "Acompte de 50 %": "Refundable up to 7 days before arrival",
            "Enfant (-2 ans)": "Child (-2 years old)",
            "Enfant (-12 ans)": "Child (-12 years old)",
            "Bébé (-2 ans)": "Baby (-2 years old)",
            "Les hébergements ne peuvent pas accueillir plus de 6 personnes":
                "Accommodation cannot accommodate more than 6 people",
            "Avec X bébé": "With {X} babies",
            Supprimer: "Remove",
            offert: "Free",
            "avis client": "Customer reviews",
            Hélène: "Hélène",
            "Rédiger un avis": "Write a review",
            "Enter title": "Enter title",
            "Enter feedback": "Enter feedback",
            "Filing of notice": "Filing of notice",
            "Thank your for feedback": "Thank your for feedback",
            "Please correct your dates": "Please correct your dates",
            Accueil: "Home",
            "500 - Internal Server Error": "Atlanticaparc.com is not available for now. PLease contact us on<br/>05 28 82 08 05 for Lodge<br/>05 28 20 02 28 for Beach",
            "Please select": "Please select",
            Filter: "Filter",
            "Please verify captcha": "Please verify captcha",
            "Please correct your participants":
                "Please correct your participants",
            "Acompte de 30 %": "50% deposit",
            "bank details description": "Bank details are only requested to guarantee the reservation, no payment is made.",
            "Taxe de séjour incluse": "Tourist tax included"
        }
    },
    fr: {
        header: {
            "Campings Clubs": "Campings Clubs",
            "Ventes Flash": "Ventes Flash",
            "A propos": "A propos",
            "On parle de nous": "On parle de nous",
            FAQ: "FAQ",
            "Contactez-nous": "Contactez-nous"
        },
        searchBar: {
            "Tous les campings clubs": "Tous les campings clubs",
            Chalets: "Chalets",
            Arrivée: "Arrivée",
            Départ: "Départ",
            adultes: "adultes",
            Rechercher: "Rechercher",
            "Please select": "Veuillez sélectionner"
        },
        app: {
            profiter: "profiter",
            "Nos offres du moment": "Nos offres du moment",
            "j’en profite": "j’en profite",
            "à partir de": "à partir de",
            découvrir: "découvrir",
            "Nos types d’hébergements": "Nos types d’hébergements",
            "NOs valeurs": "Nos valeurs",
            confort: "confort",
            "confort description":
                "Wifi offert, activités, plage ou piscine, marché, superette, un large choix au service de nos clients.",
            sécurité: "sécurité",
            "security description":
                "Une double surveillance électronique et par gardiennage.",
            propreté: "propreté",
            "cleanliness description":
                "Installations aux normes internationales, blocs sanitaires modernes.",
            services: "services",
            "service description":
                "Nos services garantissent des moments de plaisir, de repos et de confort.",
            "dernières news": "dernières news",
            "Notre actualité": "Notre actualité",
            "voir toutes les actualités": "voir toutes les actualités",
            Home: "Accueil",
            Recherche: "Recherche",
            "Camping Imourane": "Camping Imourane",
            Panier: "Panier",
            "Services et options": "Services et options",
            Options: "Options",
            Restauration: "Restauration",
            "étape 1": "étape 1",
            "Votre réservation": "Votre réservation",
            sélectionnez: "sélectionnez",
            "vos services & options": "vos services & options",
            "votre mode de paiement": "votre mode de paiement",
            "votre réservation": "votre réservation",
            "est enregistrée": "est enregistrée",
            "Retour au panier": "Retour au panier",
            Paiement: "Paiement",
            "Complétez les champs d’information et choisissez votre mode de paiement :":
                "Complétez les champs d’information et choisissez votre mode de paiement :",
            "reservation on behalf of": "réservation au nom de",
            Prénom: "Prénom",
            Nom: "Nom",
            "Adresse Email": "Adresse Email",
            Téléphone: "Téléphone",
            "Mode de paiement": "Mode de paiement",
            "Je paie": "Aucun paiement n’est nécessaire aujourd’hui par carte.",
            "un acompte pour confirmer ma réservation*":
                "Vous paierez pendant votre séjour*",
            "the rest to be paid will be paid on site":
                "",
            "Payer par carte bleue": "Réserver par carte bancaire",
            Virement: "Virement",
            "Numéro de carte": "Numéro de carte",
            Month: "Mois",
            Year: "Année",
            "Code de sécurité": "Code de sécurité",
            "Nom du titulaire": "Nom du titulaire",
            "*Remboursable jusqu’à 30 jours avant le début du séjour":
                "*Remboursable jusqu’à 2 jours avant le début du séjour",
            "J’accepte les": "J’accepte les",
            "Conditions Générales de Vente": "Conditions Générales de Vente",
            "J’accepte de recevoir des offres ou informations de la part d’Atlantica Parc":
                "J’accepte de recevoir des offres ou informations de la part d’Atlantica Parc",
            "Procéder au paiement": "Procéder au paiement",
            "Paiement par virement": "Paiement par virement",
            "Nous vons avons envoyé un récapitulatif de votre réservation ainsi qu’un":
                "Nous vons avons envoyé un récapitulatif de votre réservation ainsi qu’un",
            "Relevé d’identé Bancaire sur l’adresse mail indiquée.":
                "Relevé d’identé Bancaire sur l’adresse mail indiquée.",
            "Nous vous invitons à effectuer le virement sur le compte indiqué. Votre réservation restera":
                "Nous vous invitons à effectuer le virement sur le compte indiqué. Votre réservation restera",
            "enregistrée pendant 5 jours,</b> jusqu’à réception de votre paiement. Si le paiement n’est pas reçu dans les 5 jours ouvrés,":
                "enregistrée pendant 5 jours,</b> jusqu’à réception de votre paiement. Si le paiement n’est pas reçu dans les 5 jours ouvrés,",
            "la réservation sera annulée.": "la réservation sera annulée.",
            "contacter notre service client": "contacter notre service client",
            "en savoir plus": "en savoir plus",
            "On parle de nous": "On parle de nous",
            Blog: "Blog",
            "Featured Blogs": "Article à la une",
            "View all": "Voir tout",
            "Related posts": "Articles Similaires",
            adultes: "adultes",
            "réserver dans ce parc": "réserver dans ce parc",
            localisation: "localisation",
            "Offer title": "Offres d'emploi",
            "Current Openings": "Offres d'emploi",
            Apply: "Voir plus",
            "Toutes catégories": "Toutes catégories",
            "Filtrer par": "Filtrer par",
            Du: "Du",
            au: "au",
            "A propos": "A propos",
            CGU: "CGU",
            CGV: "CGV",
            "Plan de site": "Plan de site",
            "Offres d’emplois": "Offres d’emplois",
            "Mentions Légales": "Mentions Légales",
            "Modalités de Paiement": "Modalités de Paiement",
            Services: "Services",
            résultats: "résultats",
            offres: "offres",
            "correspondent à votre recherche":
                "Il n'y a plus de disponibilités sur ces dates",
            "Voir nos offres disponibles": "Voir nos offres disponibles",
            jeu: "jeu",
            "Most read": "Les plus lus",
            "(en 2 min Chrono)": "(en 2 min Chrono)",
            choisissez: "choisissez",
            "Date d’arrivée": "Date d’arrivée",
            "Date de départ": "Date de départ",
            "Total Services": "Total Services",
            Total: "Total",
            Modifier: "Modifier",
            Valider: "Valider",
            Adultes: "Adultes",
            "plus d’infos": "plus d’infos",
            "par personne": "par personne",
            Ajouter: "Ajouter",
            "Code Promo": "Code Promo",
            Voucher: "Voucher",
            "Your code promo is not valid": "Le code promo est invalide",
            équipement: "équipement",
            Situation: "Photos",
            "Nos services et activités": "Nos services et activités",
            "Share this story": "Partager cet article",
            "This field is required": "Ce champ est requis",
            "First name is required": "Le prénom est requis",
            "Last name is required": "Le nom est obligatoire",
            "Email address is required": "Adresse e-mail est nécessaire",
            "Telephone is required": "Le téléphone est requis",
            "Card number is required": "Le numéro de carte est requis",
            "Month is required": "Le mois est requis",
            "Year is required": "L'année doit être composée de 4 chiffres",
            "Cvv is required": "Le cvv est requis",
            "Name is required": "Le nom est requis",
            "Date expiration": "Date d'expiration",
            Code: "Code",
            "An error occurred during your payment":
                "Une erreur est survenue lors de votre paiement.",
            "Veuillez recommencer": "Veuillez effectuer une nouvelle réservation",
            Send: "Envoyer",
            "Contact Us": "Contactez-nous",
            "Campings Clubs": "Campings Clubs",
            "Enter name": "Votre nom",
            "Enter email": "Votre email",
            "Your message": "Votre message",
            "Thank your for contact": "Merci de nous avoir contacté",
            Successfully: "Succès",
            "Offre promotionnelle": "Offre promotionnelle",
            "Taxes de séjour": "Taxes de séjour",
            "Total de l’hébergement": "Total de l’hébergement",
            "CGU & CGV": "CGU & CGV",
            "vente flash": "Vente flash",
            Adulte: "Adulte",
            Adolescent: "Adolescent",
            Enfant: "Enfant",
            Animal: "Animal",
            "étape suivante": "étape suivante",
            jours: "jours",
            nuits: "nuits",
            nuit: "nuit",
            child: "Enfant",
            bébé: "bébé",
            Inclus: "Annexes",
            réserver: "réserver",
            "Your reservation is confirmed": "Votre réservation est confirmée",
            "Your reservation failed": "Les dates choisies ne sont plus disponibles, rafraîchissez le site en tapant CTRL + R sur votre clavier et faites à nouveau une recherche de disponibilités",
            "We have sent a summary of your reservation to the email address provided":
                "Nous vons avons envoyé un récapitulatif de votre réservation sur l’adresse mail indiquée.",
            "Nous vous remercions de votre confiance":
                "Nous vous remercions de votre confiance",
            "Back to the homepage": "Retour à la page d'accueil",
            "Please correct expiration":
                "Merci de corriger la date d'expiration",
            Error: "Erreur",
            "Please select camping, type, date from, date to, adults":
            "Merci de bien remplir tous les champs pour faire une recherche",
            "Please complete all fields":
                "Veuillez compléter tous les champs de la recherche",
            "Acompte de 50 %": "Annulation possible 7 jours avant l'arrivée",
            "Enfant (-2 ans)": "Enfant (-2 ans)",
            "Enfant (-12 ans)": "Enfant (-12 ans)",
            "Bébé (-2 ans)": "Bébé (-2 ans)",
            "Les hébergements ne peuvent pas accueillir plus de 6 personnes":
                "Les hébergements ne peuvent pas accueillir plus de 6 personnes",
            "Avec X bébé": "Avec {X} bébé",
            Supprimer: "Supprimer",
            offert: "offert",
            "avis client": "avis client",
            Hélène: "Hélène",
            "Rédiger un avis": "Rédiger un avis",
            "Enter title": "Titre",
            "Enter feedback": "Votre avis",
            "Filing of notice": "Dépôt d'un avis",
            "Thank your for feedback": "Merci pour votre avis",
            "Please correct your dates": "Merci de corriger les dates",
            Accueil: "Accueil",
            "500 - Internal Server Error": "Le site est hors service Merci de contacter la réception<br/>Au Lodge : 05 28 82 08 05<br/>Au Beach : 05 28 20 02 28",
            "Please select": "Veuillez sélectionner",
            Filter: "Filtrer",
            "Please verify captcha": "Veuillez vérifier captcha",
            "Please correct your participants":
                "Veuillez corriger vos participants",
            "Acompte de 30 %": "Acompte de 50 %",
            "bank details description": "Les coordonnées bancaire sont uniquement demandées pour garantir la réservation, aucun paiement n'est effectué.",
            "Taxe de séjour incluse": "Taxe de séjour incluse"
        }
    }
};
Vue.use(VueI18n);
export const languages = ["en", "fr"];
export default new VueI18n({
    locale: "fr", // set locale
    fallbackLocale: "fr", // set fallback locale
    messages // set locale messages
});
